import { DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';


const DialogResult = ({
  title,
  message,
  btnText,
  open,
  handleClose,
  handleOk
}: {
  title?: string | undefined;
  message: string | undefined;
  btnText: string | undefined;
  open: boolean;
  handleClose: () => void;
  handleOk: () => void;
}) => {
  const handleConfirm = () => {
    handleOk();
    handleClose();
  };

  const handleCloseDialog = (event: any, reason: string) => {
    if (reason && reason === 'backdropClick') return;
    handleClose();
  };

  return (
    <div>
      <Dialog
        className="dialog-confirm dialog-result"
        open={open}
        onClose={handleCloseDialog}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant='h5'>{title}</Typography>
          <DialogContentText
            className="dialog-confirm-content"
            id="alert-dialog-description"
          >
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="ok-button" onClick={handleConfirm} autoFocus>
            {btnText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogResult;
